import { handleResponseWithNon200Errors, makeGet } from './helpers';

/**
 * @category Item API
 * @see fetchCityStateSuggestion
 */
type FetchCityAndStateByZipParams = {
    authToken: string;
    deployment: string;
    zipcode: string;
};
/**
 * Gets a US city and state suggestion from given zip code
 * @function fetchCityStateSuggestion
 * @category Item API
 * @param {FetchCityAndStateByZipParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/zipcodecity
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/get-city-state-from-zip.ts
 */
export const fetchCityStateSuggestion = ({ authToken, deployment, zipcode }: FetchCityAndStateByZipParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'zipcodecity',
            authToken,
            deployment,
            path: '<ITEM-API>',
            queryParams: { zipcode },
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });
